import { MemberService } from "@/generated/services/MemberService";
import { useQuery } from "@tanstack/react-query";

export function useFetchMember(memberId?: number) {
  return useQuery({
    queryKey: ["member", memberId],
    enabled: !!memberId,
    queryFn: async () => {
      if (!memberId) throw new Error("Invalid member ID");

      const response = await MemberService.getMembers(memberId);

      return {
        ...response,
      };
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
}
